import { action, observable } from 'mobx'

import Ds from './ds'

class CompanyStates {
  @observable data = []

  @observable ds = new Ds()

  @action loadAllCompanyStates(callback) {
    this.ds.query(`{ companyStates(hash: "${ localStorage.getItem('userHash') }") { id name } }`, (data) => {
      this.data = data.companyStates

      if (callback) {
        return callback();
      }
    })
  }

  @action newCompanyState(name) {
    this.ds.query(`mutation { addCompanyState(name: "${ name }", hash: "${ localStorage.getItem('userHash') }") { id } }`, (data) => {
      this.loadAllCompanyStates()
    })
  }

  @action updateCompanyState(id, name) {
    this.ds.query(`mutation { updateCompanyState(id: ${ id }, name: "${ name }", hash: "${ localStorage.getItem('userHash') }") { id } }`, (data) => {
      this.loadAllCompanyStates()
    })
  }

  @action deleteCompanyState(id) {
    this.ds.query(`mutation { deleteCompanyState(id: ${ id }, hash: "${ localStorage.getItem('userHash') }") { id } }`, (data) => {
      this.loadAllCompanyStates()
    })
  }
}

export default new CompanyStates



// WEBPACK FOOTER //
// ./src/stores/companystates.js